import React, { useState, useEffect } from "react";

import coins from "../../libs/coins/coins.json";

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

type Props = {
  balance?: number;
  selectedCoin?: string;
};

export default function SelectCoin(props: Props) {
  const { selectedCoin } = props;
  const coin_list = coins;
  const [select, setSelect] = useState(
    coin_list.find((c) => c.address === props.selectedCoin)
  );

  useEffect(() => {
    const selectedItem = coin_list.find((c) => c.address === selectedCoin);
    setSelect(selectedItem);
  }, [coin_list, selectedCoin]);

  return (
    <div>
      <div className="flex flex-col items-center">
        <div className="px-2 py-1 border-none rounded-full bg-primary-200 bg-opacity-100 flex items-center gap-2">
          <img alt="Coin" width={30} src={select?.logoURI} />
          <span className="text-[15px] whitespace-nowrap font-semibold text-white">
            {select?.name}
          </span>
        </div>
        <div className="text-base text-left mt-3 text-white">
          Balance:
          <span style={{ color: "#2196f3", marginLeft: "11px" }}>
            {props.balance ? Number(props.balance) : "0.00"}
          </span>
        </div>
      </div>
    </div>
  );
}
